import React from "react";
import { Switch, FormControlLabel, styled } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 52,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    padding: 5,
    "&.Mui-checked": {
      transform: "translateX(18px)", 
      "& + .MuiSwitch-track": {
        backgroundColor: "#9DC655", 
      },
    },
    "&:hover": {
      backgroundColor: "transparent", 
    },
  },
  "& .MuiSwitch-thumb": {
    width: 24, 
    height: 24,
    borderRadius: "50%", 
    backgroundColor: "#fff", 
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: '5px',
    "& svg": {
      fontSize: 16,
      color: "#000", 
    },
    "&:hover": {
      backgroundColor: "transparent", 
    },
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: "#F44336", 
    opacity: 1,
  },
}));

const CircleWithIcon = ({ privateMode }) => {
  const circleStyle = {
    width: '17px',
    height: '17px',
    borderRadius: '50%',
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    marginLeft: '3.5px',
    marginTop: '3.5px',
  };

  const iconStyle = {
    color: 'black',
    fontSize: 'small',
  };

  return (
    <div style={circleStyle}>
      {privateMode ? (
        <RemoveRedEyeOutlinedIcon style={iconStyle} />
      ) : (
        <VisibilityOffOutlinedIcon style={iconStyle} />
        
      )}
    </div>
  );
};

const IconSwitch = ({ privateMode, setPrivateMode, userInfo }) => {
  const handleChange = (event) => {
    setPrivateMode(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <CustomSwitch
          checked={privateMode}
          onChange={handleChange}
          icon={<CircleWithIcon privateMode={privateMode} />}
          checkedIcon={<CircleWithIcon privateMode={privateMode} />}
        />
      }
      label="Private Mode"
      labelPlacement="start"
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: '14px',
          fontFamily: 'Manrope, sans-serif',
          fontWeight: 400,
          '@media (max-width: 380px)': {
            fontSize:'15px'
          },
        }
      }}
    />

  );
};

export default IconSwitch;
